const ROOT_API = process.env.VUE_APP_ROOT_API;

const LOGIN = ROOT_API + 'auth/login.php';
const LOGOUT = ROOT_API + 'auth/logout.php';
const CHECK_LOGIN = ROOT_API + 'auth/check_login.php';
const GET_USER_INFO = ROOT_API + 'auth/get_user_info.php';

export default {
  namespaced: true,

  state: {
    userId: null,
  },

  getters: {
    isLogged: state => state.userId && state.userId !== '-1'
  },

  mutations: {
    setUserId(state, userId) {
      state.userId = userId;
    }
  },

  actions: {
    login(context, creds) {
      const { commit } = context;

      const form = new FormData();
      form.append('username', creds.username);
      form.append('password', creds.password);
      form.append('remember', creds.remember);

      return fetch(LOGIN, {
        method: 'post',
        body: form,
        credentials: 'include'
      })
      .then(res => res.text())
      .then(res => {
        if (!isNaN(+res)) {
          commit('setUserId', res);
          return res;
        } else {
          return '-1';
        }
      })
      .catch(err => {
        commit('setUserId', '-1');
        throw err;
      });
    },

    logout(context) {
      const { commit } = context;

      return fetch(LOGOUT, {
        credentials: 'include',
        method: 'post'
      })
      .catch(err => {
        throw err;
      })
      .finally(() => {
        commit('setUserId', '-1');
      });
    },

    checkLogin(context) {
      const { state, getters, commit } = context;

      if (getters.isLogged) {
        return Promise.resolve(true);
      }

      return fetch(CHECK_LOGIN, {
        credentials: 'include',
        method: 'post'
      })
      .then(res => res.text())
      .then(res => {
        if (!isNaN(+res)) {
          commit('setUserId', res);
        }
        else {
          commit('setUserId', '-1');
        }
        return Promise.resolve(getters.isLogged);
      })
      .catch(err => {
        commit('setUserId', '-1');
        throw err;
      });
    }
  }
};